<template lang="pug">
.box.chart
  select(v-model="selectedRange")
    option(v-for="[key, range] in Object.entries(ranges)", :value="key") {{ range.label }}
  bar-chart-inner(:data="data") 
</template>

<script>
import ApiService from "../services/api";
import BarChartInner from "../components/BarChartInner";

export default {
  components: { BarChartInner },
  props: {
    query: String,
    payload: {
      type: Object,
      default: () => { },
    },
  },

  data: () => ({
    data: null,
    selectedRange: "week",
    ranges: {
      hour: {
        label: "This hour",
        intervalAmount: 60,
        intervalUnit: "minute",
        intervalSize: 1,
        markers: 1,
      },
      day: {
        label: "This day",
        intervalAmount: 24,
        intervalUnit: "hour",
        intervalSize: 1,
        markers: 8,
      },
      week: {
        label: "This week",
        intervalAmount: 24 * 7,
        intervalUnit: "hour",
        intervalSize: 1,
        markers: 8,
      },
      month: {
        label: "This month",
        intervalAmount: 30,
        intervalUnit: "day",
        intervalSize: 1,
        markers: 7,
      },
      two_months: {
        label: "Two Months",
        intervalAmount: 60,
        intervalUnit: "day",
        intervalSize: 1,
        markers: 30,
      },
      three_months: {
        label: "Three Months",
        intervalAmount: 90,
        intervalUnit: "day",
        intervalSize: 1,
        markers: 30,
      },
      year: {
        label: "This Year",
        intervalAmount: 965,
        intervalUnit: "day",
        intervalSize: 1,
        markers: 30,
      },
    },
  }),

  mounted() {
    this.fetchData();
  },

  watch: {
    selectedRange() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      this.data = null;

      const range = this.ranges[this.selectedRange];

      const intervalSlice =
        "interval '" + range.intervalSize + " " + range.intervalUnit + "'";

      const sqlTimeSeries = `generate_series(
            date_trunc('${range.intervalUnit
        }', now() - interval '${range.intervalAmount - 1} ${range.intervalUnit
        }'),
            date_trunc('${range.intervalUnit}', now()),
            ${intervalSlice}
        ) x`;


      const parsed = this.query.replace("START", `x`).replace("END", `(x + ${intervalSlice})`);

      const sqlQuery = `
        select x, (${parsed}) from ${sqlTimeSeries}
      `;
      this.data = await ApiService.query(sqlQuery, this.payload);
    },
  },
};
</script>
